export const DRAWER_CONTINUE_ON_DESKTOP = {
  continueOnYourBrowser: 'Continue on your browser',
  noBankingApp: 'No banking app?',
};
